import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Modal, ModalContent } from "@amzn/stencil-react-components/modal";
import { Text } from "@amzn/stencil-react-components/text";
import React from "react";

import { useConfirmationController } from "@/common/flow/confirmation-controller";
import { getString } from "@/common/uistringlabels/ui-string-utils";

const STRING_PATH = "discardProgressModal";

export const DiscardProgressModal: React.FC = () => {
  const request = useConfirmationController((state) => state.request);
  const settle = useConfirmationController((state) => state.settle);

  return (
    <Modal isOpen={!!request} close={() => settle(false)} isScrollable={false}>
      {request && (
        <ModalContent
          data-testid="discard-progress-modal"
          titleText={getString(`${STRING_PATH}.title`)}
          buttons={[
            <Button key="stay" onClick={() => settle(false)}>
              {getString(`${STRING_PATH}.stayButton`)}
            </Button>,
            <Button key="leave" variant={ButtonVariant.Primary} onClick={() => settle(true)}>
              {getString(`${STRING_PATH}.leaveButton`)}
            </Button>,
          ]}
        >
          <Text fontSize="T200" color="neutral90">
            {request.message}
          </Text>
        </ModalContent>
      )}
    </Modal>
  );
};
